var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFollowMode = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-scan-eye"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 7V5a2 2 0 0 1 2-2h2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 3h2a2 2 0 0 1 2 2v2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M21 17v2a2 2 0 0 1-2 2h-2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M7 21H5a2 2 0 0 1-2-2v-2"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 1
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M5 12s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5"
})));
export default SvgFollowMode;